import { Component, EventEmitter, HostListener, Input, OnInit, Output, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EChartsOption } from 'echarts';
import { iconClass } from 'src/app/enums/icon-class.enum';
import { EchartsGraph } from 'src/app/modules/ems/class/echarts-graph';
import { EchartsPieGraph } from 'src/app/modules/ems/class/echarts-pie-graph';
import { EchartsBuilderService } from 'src/app/modules/ems/services/echarts/echarts-builder.service';
import { EchartsGraphConfig } from 'src/app/modules/ems/type/EchartGraphConfig';
import { Series } from 'src/app/modules/ems/type/Series';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-switch-graph-bar-pie',
    templateUrl: './switch-graph-bar-pie.component.html',
    styleUrls: ['./switch-graph-bar-pie.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SwitchGraphBarPieComponent implements OnInit {

  @Input() unit: string[];
  @Input() series: Series;
  @Input() axis: string[];
  @Input() isPie: boolean;
  @Input() pieSize: number = environment.core.PIE_CHART_SIZE;
  @Input() breakpoint: number = environment.core.PIE_CHART_LEGEND_BREAKPOINT;

  @Output() clicked = new EventEmitter<any>();

  iconClass = iconClass;

  config: EchartsGraphConfig = {
    xAxis: ['category'],
    unit: [],
    legend: false,
    zoom: false
  }

  pieConfig: EchartsGraphConfig = {
    unit: []
  }

  options: EChartsOption = {};

  bar: EchartsGraph;
  pie: EchartsPieGraph;

  @HostListener('window:resize')
  onResize() {
    this.setOptions();
  }

  constructor(
    private echartsBuilder: EchartsBuilderService,
    public translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.setOptions();
    this.setSeries();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes) {
      this.setSeries();
    }
  }

  setOptions(){

    if(window.innerWidth < this.breakpoint) {
      this.pieConfig = {
        unit: this.unit,
        legend: false
      };
    } else {
      this.pieConfig = {
        unit: this.unit
      };
    }

    this.config.unit = this.unit;

    this.bar = this.echartsBuilder.buildSimpleGraph(this.config);
    this.pie = this.echartsBuilder.buildPieGraph(this.pieConfig);

    this.bar.setXaxisLabels([this.axis]);

    this.bar.rotateXAxis(0,30);
    this.bar.setAxisSize('x', 0, 12);
    this.bar.changeTooltip(null, 'item');

    this.pie.changePieRadius(this.pieSize);
    this.pie.changeLegendOrientation('vertical');
    this.pie.setLegendPosition({top: {value: 0}, left: {value: 0}});
  }

  setSeries(){
    this.bar.setSimpleGraphSeries([this.series]);
    this.pie.setPieSerie(this.series);
    this.options = this.getOptions(this.bar, this.pie, this.isPie);
  }

  transfertClicked(event: any): void {
    this.clicked.emit(event);
  }

  toggleChart(): void {
    this.isPie = !this.isPie;
    this.getSeries();
  }

  getSeries(){
    this.options = this.getOptions(this.bar, this.pie, this.isPie);
  }

  getOptions(bar: EchartsGraph, pie: EchartsPieGraph, toggler: boolean): EChartsOption {
    if (toggler) {
      return pie.getOptions();
    }
    if (!toggler) {
      return bar.getOptions();
    }
  }

}
